<template>
  <div
    class="activity-item rounded-lg dark:bg-zinc-900 bg-gray-50 hover:bg-slate-200 dark:hover:bg-zinc-900 transition-all duration-300 border dark:border-zinc-700"
    tabindex="0"
    @keydown.enter="openProduct(props.item, props.customOpenURL)"
    @keydown.space.prevent="openProduct(props.item, props.customOpenURL)"
    @click="openProduct(props.item, props.customOpenURL)"
    :class="{
      'focus:outline-none focus:ring-2 focus:Tourscanner_blue-source': true,
      'border-Tourscanner_blue-source dark:border-[#002A3A] dark:bg-[#002A3A] bg-Tourscanner_blue-100 hover:bg-Tourscanner_blue-200 dark:hover:bg-[#002A3A]':
        props.item.highlighted,
    }"
  >
    <div
      class="cursor-pointer"
      :class="[
        'flex pt-2 pb-1 px-2 md:p-2 max-h-[110px] md:max-h-full relative ',
        { 'h-auto': showInclusions, 'h-[410px] md:h-[195px]': !showInclusions },
      ]"
    >
      <div v-if="props.item.highlighted" class="absolute top-[-3px] md:top-1 left-[-5px] md:left-[-5px]">
        <span class="bg-Tourscanner_blue-source text-white text-sm font-semibold px-3 py-2 rounded shadow">
          {{ $t('Selected Product') }}
        </span>
      </div>
      <div v-if="props.item.available != null" class="overflow-hidden">
        <div v-if="props.item.available" class="absolute top-[-3px] md:top-1 left-[-5px] md:left-[-5px] z-10">
          <span class="bg-[#157e3f] text-white text-xs font-semibold px-2 py-1 rounded shadow">
            {{ $t('Available') }}
          </span>
        </div>
        <div v-else class="absolute top-1 md:top-1 left-3 md:left-3 z-10">
          <span class="bg-yellow-500 text-white text-xs font-semibold px-2 py-1 rounded shadow">
            {{ $t('Maybe Available') }}
          </span>
        </div>
      </div>
      <SmartImg
        class="w-24 h-24 md:w-[10.5rem] md:h-[11.3rem] object-cover rounded-lg bg-gray-300 dark:bg-gray-600"
        :src="item.thumb"
        alt="Tour Image"
        sizes="(max-width: 250px) 150px, 150px"
        :ratio="1"
      />

      <div class="pl-2 md:pl-3 md:pr-1 flex flex-col md:justify-between flex-grow">
        <!-- <div v-if="tags().length > 0" class="relative mb-2 overflow-hidden">
          <div class="overflow-x-auto whitespace-nowrap no-scrollbar hidden">
            <span
              v-for="tag in tags()"
              :key="tag"
              class="inline-flex items-center bg-blue-100 text-blue-800 text-sm font-medium px-2.5 py-1 rounded-lg mr-2 flex-shrink-0 dark:bg-blue-800 dark:text-blue-200"
            >
              <img v-if="tag.icon" :src="tag.icon" alt="" class="w-4 h-4 mr-1 dark:invert dark:invert-1" />
              <i v-else-if="tag.iconClass" :class="tag.iconClass" class="w-4 h-4 mr-1 dark:invert dark:invert-1"></i>
              <span class="font-semibold text-dark dark:text-white leading-tight">{{ tag.name }}</span>
            </span>
          </div>
        </div> -->

        <h2
          class="text-xl md:text-2xl leading-tight font-semibold text-zinc-900 dark:text-white line-clamp-6 md:line-clamp-6"
        >
          {{ item.name }}
        </h2>

        <div v-if="item.reviews_count" class="flex mt-2">
          <StarRating
            :reviews_count="item.reviews_count"
            :filled_stars="filledStars"
            :has_half_star="hasHalfStar"
            :rating="item.reviews_avg"
          ></StarRating>
        </div>

        <div class="md:flex justify-between items-end mt-auto h-38 hidden">
          <ActivityDetails
            :item="item"
            :duration="duration"
            :languages="languages()"
            :selectedLanguages="selectedLanguages"
            :whatsIncluded="whatsIncluded"
            :toggleExpand="toggleExpand"
            :whatsIncludedExpanded="showInclusions"
            :activityPrice="activityPrice"
          ></ActivityDetails>
        </div>
        <div
          v-if="showInclusions && whatsIncluded().length > 0"
          class="activity-card-whatsincluded hidden md:flex md:flex-col gap-1 mt-2"
        >
          <div class="activity-info-box flex items-center gap-1.5">
            <span class="icon_info-circle icon_medium"></span>
            <span class="icon_chevron-right-activity-card icon_medium"></span>
          </div>
          <ul class="activity-card-inclusions flex flex-col">
            <li v-for="inclusion in whatsIncluded()" class="flex items-start gap-2">
              <img src="/img/icons/task_alt.svg" class="w-4 dark:filter dark:invert dark:invert-1 mt-1" />
              <span class="text-md leading-normal">{{ inclusion }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex px-2 pt-0 pb-2 md:py-2 md:hidden">
      <ActivityDetails
        :item="item"
        :duration="duration"
        :languages="languages()"
        :selectedLanguages="selectedLanguages"
        :whatsIncluded="whatsIncluded"
        :toggleExpand="toggleExpand"
        :whatsIncludedExpanded="showInclusions"
        :activityPrice="activityPrice"
      ></ActivityDetails>
    </div>

    <div
      v-if="showInclusions && whatsIncluded().length > 0"
      class="activity-card-whatsincluded flex flex-col md:hidden gap-1 mt-2 px-2 pb-4"
    >
      <div class="activity-info-box flex items-center gap-1.5">
        <span class="icon_info-circle icon_medium"></span>
        <span class="icon_chevron-right-activity-card icon_medium"></span>
      </div>
      <ul class="activity-card-inclusions flex flex-col">
        <li v-for="inclusion in whatsIncluded()" class="flex items-start gap-2 space-y-1">
          <img src="/img/icons/task_alt.svg" class="w-4 dark:filter dark:invert dark:invert-1 mt-2" />
          <span class="text-md leading-normal">{{ inclusion }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import SmartImg from '~/components/SmartImg.vue';
import { formatHours, openProduct } from './utils';

const isDev = process.dev;

const { t } = useI18n();

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  selectedLanguages: {
    type: Array,
    required: false,
    default: () => [],
  },
  customOpenURL: {
    type: String,
    required: false,
  },
});

const filledStars = computed(() => Math.floor(props.item.reviews_avg));
const hasHalfStar = computed(() => props.item.reviews_avg - filledStars.value >= 0.5);

const formatTag = function (tag) {
  const words = tag.split(' ');

  return words
    .map((word) => {
      return word ? word[0].toUpperCase() + word.substring(1) : '';
    })
    .join(' ');
};

const tags = function () {
  let res = [];
  if (props.item.has_audio_guide == 1) {
    res.push({
      icon: '/img/icons/audio_guide.svg',
      name: formatTag(t('Audio Guide')),
    });
  }
  if (props.item.has_live_guide == 1) {
    res.push({
      icon: '/img/icons/guided_tour.svg',
      name: formatTag(t('Guided Tour')),
    });
  }
  if (props.item.wheelchair == 1) {
    res.push({
      icon: '/img/icons/wheelchair-accessible.png',
      name: formatTag(t('Wheelchair')),
    });
  }
  if (props.item.private == 1) {
    res.push({
      icon: '/img/icons/diamond.svg',
      name: formatTag(t('Private Tour')),
    });
  }
  if (props.item.smartphone_ticket == 1) {
    res.push({
      icon: '/img/icons/smartphone.svg',
      name: formatTag(t('Smarthphone Ticket')),
    });
  }
  if (props.item.night == 1) {
    res.push({
      icon: '/img/icons/moon.svg',
      name: formatTag(t('Night Tour')),
    });
  }
  if (props.item.ticket_included == 1) {
    res.push({
      icon: '/img/icons/local_activity.svg',
      name: formatTag(t('Ticket Included')),
    });
  }
  return res;
};

const activityPrice = function () {
  let price = props.item.price / 100;
  if (props.item.discount > 0) {
    let fullPrice = price / (1 - props.item.discount / 100);
    return {
      price: price,
      discount: props.item.discount,
      fullPrice: fullPrice,
    };
  } else {
    return {
      price: price,
      discount: false,
      fullPrice: price,
    };
  }
};

const whatsIncluded = function () {
  if (!props.item.included) return [];

  let textOnly = props.item.included.replace(/<[^>]*>/g, '') || '';

  const array = textOnly.split('\n') || [];
  const res = array.map((el) => el.replace(/^(?:\* )+/, '')).filter((el) => el.trim() !== '');
  return res;
};

const languages = function () {
  if (!props.item.languages) return [];
  return props.item.languages;
};

const duration = formatHours(props.item.duration, t);

let showInclusions = ref(false);
const toggleExpand = function () {
  showInclusions.value = !showInclusions.value;
};

const handleKeyDown = function (event) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    openProduct(props.item);
  }
};
</script>

<style scoped>
.focus-visible:focus {
  outline: 2px solid #4a90e2;
  outline-offset: 2px;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
